import { AdService } from '@/api/types/services.types';

export function getLessPrice(service: AdService) {
  if (service.previousPrice === null) return service.price;
  return Math.min(service.price, service.previousPrice);
}

export function hasOneSale(service: AdService) {
  if (service.previousPrice === null) return false;
  return service.price < service.previousPrice;
}

export function hasSales(services: AdService[]) {
  return services.some(hasOneSale);
}

export function isNovelty(service: AdService) {
  return service.previousPrice === null;
}
